import _join from 'lodash/join';
import _split from 'lodash/split';

export const defaultColor = {
  color: '#d39e7a',
  shimmerIntensity: 50,
  colorIntensity: 50,
};

export default {
  initSku: (skuType, platformData) => ({
    skuType,
    gtin: '',
    skuNo: '',
    skuName: platformData? platformData.platformProductName: '',
    colors: [defaultColor],
    patternGuid: 'patten_eyeshadow_1color_a',
    image: '',
    shopUrl: '',
    platform: platformData? platformData.platform: '',
    platformPermalink: platformData? platformData.platformPermalink: '',
    platformProductId: platformData? platformData.platformProductId: '',
    enabled: true,
  }),
  fromDb: v => {
    const pattern = v.patterns && !!v.patterns.length && v.patterns[0];
    return {
      id: v.id ? v.id : v.skuId,
      skuType: v.skuType,
      skuNo: v.skuNo,
      gtin: v.gtin,
      skuName: v.i18n && v.i18n.enu && v.i18n.enu.skuName,
      colors:
        v.colors &&
        !!v.colors.length &&
        v.colors.map((c, i) => ({
          color: c.colorCode,
          shimmerIntensity: c.shimmerIntensity,
          colorIntensity:
            pattern &&
            pattern.colorIntensities &&
            _split(pattern.colorIntensities, ',')[i],
        })),
      color:
        v.colors &&
        !!v.colors.length &&
        v.colors.map((c, i) => ({
          color: c.colorCode,
          shimmerIntensity: c.shimmerIntensity,
          colorIntensity:
            pattern &&
            pattern.colorIntensities &&
            _split(pattern.colorIntensities, ',')[i],
        })),
      patternGuid: pattern && pattern.patternGuid,
      imageUrl: v.imageUrl,
      createdTime: v.createdTime,
      lastModified: v.lastModified,
      skuStatus: v.skuStatus,
      enabled: v.skuStatus === 'ENABLED',
      productId: v.productId,
      productNo: v.productNo,
      productName: v.productName,
      shopUrl: v.shopUrl,
      platform: v.platform? v.platform: '',
      platformPermalink: v.platformPermalink,
      platformProductId: v.platformProductId? v.platformProductId: '',
    };
  },
  toDb: v => ({
    sku: {
      id: v.id ? v.id : v.skuId,
      skuType: v.skuType,
      skuNo: v.skuNo,
      skuStatus: v.skuStatus,
      gtin: v.gtin,
      i18n: {
        enu: {
          skuName: v.skuName,
        },
      },
      colors:
        v.colors &&
        !!v.colors.length &&
        v.colors.map(c => ({
          colorCode: c.color,
          shimmerIntensity: c.shimmerIntensity,
        })),
      patterns: [
        {
          patternIndex: 0,
          patternGuid: v.patternGuid,
          colorIndexes:
            v.colors &&
            !!v.colors.length &&
            _join(v.colors.map((_, i) => i), ','),
          colorIntensities:
            v.colors &&
            !!v.colors.length &&
            _join(v.colors.map(c => c.colorIntensity), ','),
        },
      ],
      image: v.image,
      imageUrl: v.imageUrl,
      productId: v.productId,
      productNo: v.productNo,
      productName: v.productName,
      shopUrl: v.shopUrl,
      platform: v.platform,
      platformPermalink: v.platformPermalink,
      platformProductId: v.platformProductId,
    },
    enabled: true,
  }),
};
